function createCookie(name, value, days) {
  var expires = '';

  if(days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = '; expires=' + date.toUTCString();
  }

  document.cookie = name + '=' + value + expires + '; path=/';
}

function readCookie(name) {
  var nameEQ = name + '=';
  var ca = document.cookie.split(';');

  for(var i = 0; i < ca.length; i++) {
    var c = ca[i];

    while(c.charAt(0) == ' ') {
      c = c.substring(1, c.length);
    }

    if(c.indexOf(nameEQ) == 0) {
      return c.substring(nameEQ.length, c.length);
    }
  }

  return null;
}

function eraseCookie(name) {
  createCookie(name, '', -1);
}

function deviceType() {
  var type = '';
  var subtype = '';
  var os = 'undefined';
  var browser = 'undefined';

  if(!!navigator.userAgent) {
    // Edge userAgent contains 'Chrome'
    if(/Edge/.test(navigator.userAgent)) browser = 'edge';
    // Chrome userAgent contains 'Safari'
    else if(/Chrome/.test(navigator.userAgent)) browser = 'chrome';
    else if(/Safari/.test(navigator.userAgent)) browser = 'safari';
    else if(/Firefox/.test(navigator.userAgent)) browser = 'firefox';

    if(/Android/.test(navigator.userAgent)) os = 'android';
    else if(/Windows/.test(navigator.userAgent)) os = 'windows';
    else if(/Linux/.test(navigator.userAgent)) os = 'linux';
    else if(/(Macintosh| Mac OS)/.test(navigator.userAgent)) os = 'mac';
  }

  if(!!navigator.platform) {
    if(/(iPad|iPhone|iPod)/.test(navigator.platform)) os = 'iOS';
    else if(/MacIntel/.test(navigator.platform)) os = 'mac';
  }

  var width = outerWidth > innerWidth ? innerWidth : outerWidth;

  if(width < 768) type = 'mobile';
  else if(width < 1000) type = 'tablet';
  else if(width < 1366) { type = 'desktop'; subtype = 'desktop1024'; }
  else if(width < 1920) { type = 'desktop'; subtype = 'desktop1366'; }
  else if(width < 2000) { type = 'desktop'; subtype = 'desktop1920'; }
  else { type = 'desktop'; subtype = 'desktopMax'; }
  
  var currDevice = os + browser + type + subtype;

  window.device = {
    os: os,
    browser: browser,
    type: type,
    subtype: subtype
  };
  
  window.onDeviceChangeFns = window.onDeviceChangeFns || [];
  window.lastDevice = window.lastDevice || '';
  
  if(lastDevice != currDevice) {
    lastDevice = currDevice;

    document.body.classList.remove('android', 'windows', 'linux', 'mac', 'iOS'); // os
    document.body.classList.remove('edge', 'chrome', 'safari', 'firefox'); // browsers
    document.body.classList.remove('desktop', 'tablet', 'mobile', 'undefined'); // devices
    document.body.classList.remove('desktop1024', 'desktop1366', 'desktop1920', 'desktopMax'); // desktop screen
    
    document.body.classList.add(os, browser, type);
    subtype && document.body.classList.add(subtype);

    onDeviceChangeFns.map(function(fn) { fn() });
  }

  return true;
}

function onDeviceChange(fn, prevent) {
  onDeviceChangeFns.push(fn);
  !prevent && fn();
}

function onExists(key, cb) {
  let interval = setInterval(() => {
    if(window[key] !== undefined) {
      clearInterval(interval);
      cb && cb();
    }
  });
}

function onElementExists(selector, callback, timeout) {
	if(!timeout) {
		var timeout = { val: false };

		timeout.obj = setTimeout(function() {
			timeout.val = true;
		}, 20 * 1000);
	}

	var element;

	if(element = $_(selector)) {
		callback && callback(element);
		clearTimeout(timeout.obj);
	}

	else if(!timeout.val) {
		window.requestAnimationFrame(function() {
			onElementExists(selector, callback, timeout);
		});
	}
}

function $_(n, t) {
  return t ? t.querySelector.call(t, n) : document.querySelector.apply(document, arguments);
}

function $$(n, t) {
  var nl = t ? t.querySelectorAll.call(t, n) : document.querySelectorAll.apply(document, arguments);
  return Array.from(nl);
}

function HttpRequest(type, url, data, callback, format) {
  var formData = new FormData();
  
  if(typeof data == 'function') {
    if(typeof callback == 'string') {
    	format = callback;
    }
    
  	callback = data;
    data = [];
  }

  for(key in data) {    
    formData.append(key, data[key]);
  }

  var xmlHttp = new XMLHttpRequest();
  
  xmlHttp.onreadystatechange = function() {
    if(xmlHttp.readyState == 4 && xmlHttp.status == 200) {
      var response = xmlHttp.responseText;
      
      if(format == 'json') response = JSON.parse(response);
      
      callback && callback(response);
    }
  }
  
  xmlHttp.open(type, url); 
  xmlHttp.send(formData); 
}

function addStyle(styles, id) {
  var css = document.createElement('style');
  
  css.type = 'text/css';
  
  if(id) css.id = id;

  if (css.styleSheet) {
    css.styleSheet.cssText = styles;
  } else {
    css.appendChild(document.createTextNode(styles));
  }
  
  $_('head').appendChild(css);
}

function searchParams(search) {
  search = search[0] == '?' ? search.substring(1) : search;
  search = search.split('&');

  var data = {};

  for (let qstr of search) {
    qstr = qstr.split('=');

    if(qstr.length == 2) {
      data[qstr[0]] = decodeURIComponent(qstr[1]);
    }
  }
  
  return data;
}

function slugify(str) {
  str = str.normalize ? str.normalize('NFD') : str;
  str = str.replace(/[\u0300-\u036f]/g, '');
  //str = str.replace(/[^a-z0-9-\s]/gi, '').trim();
  str = str.replace('NFD').replace(/\s+/g, '-');
  str = str.toLowerCase();

  return str;
}

function showVariantPhotos(color) {
  var productTitle = $('.breadcrumb__link--current').text();
  
  if($('.product-single__photo__img[alt="'+productTitle+'"]').length) return false;
  
  var $slider = $('.slick-slider');
  var $dots = $('.js-product-slider-nav-dots');
  
  $('.product-single__photo-thumbs__img').each(function() {
    $(this).closest('li').show();
  });
  
  $('.product-single__photo-thumbs__img:not([alt*="'+color+'"]):not([alt*="Any"])').each(function() {
    $(this).closest('li').hide();
  });
  
  var dots = $dots.html();
  
  $slider.slick('slickUnfilter').slick('slickFilter', function() {
    return $(this).find('img[alt*="'+color+'"], img[alt*="Any"]').length;
  });
  
  var index = 0;
  
  $dots.html(dots).find('li').each(function() {
    if(this.style.display != 'none') {
      var n_slide = index;
      
      $(this).click(function() {
      	$slider.slick('slickGoTo', n_slide);
        setActiveDot(n_slide);
      });
      
      $(this).attr('index', index++);
    }
  });
  
  $slider.on('afterChange', function(e, slick, index) {
    setActiveDot(index);
  });
  
  setActiveDot($('.slick-current').index());
  
  function setActiveDot(index) {
  	$dots.find('li').removeClass('slick-active');
  	$dots.find('li[index='+index+']').addClass('slick-active');
  }
}

function showVariantDescription(values) {
  $('description').show().each(function() {
    var $description = $(this);
    var show = true;

    for(var option in values) {
      var value = values[option];      
      
      var attr = slugify(option).toLowerCase();
      var attrValue = $description.attr(attr);

      if(attrValue != undefined && attrValue != value) {
        show = false;
      }
    }

    $description.toggle(show);
  });
}